// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import { getPortfolioSnapshot } from '../../actions/portfolios'
import ComponentContainer from '../container-component'
import RiskProfileComponent from './risk-profile'
import { StyledContent } from './style'

class RiskProfile2 extends Component {
  
  state = {
    isLoading: true,
    selectedTrade: null,
  }
  
  componentDidMount() {
   this.getPortfolioSnapshot();
    
  }
  
  getPortfolioSnapshot = () => {
    try {
      const selectedTrade = localStorage.getItem('selectedTrade');
      if (selectedTrade) {
        this.setState({
          selectedTrade: JSON.parse(selectedTrade),
          isLoading: false,
        })
      } else {
        this.setState({
          error: 'There is no trade saved to analyze!'
        })
      }
    } catch(err) {
      this.setState({
        error: 'There is no trade saved to analyze!'
      })
    }
  }
  
  render() {
    const {selectedTrade, error, isLoading } = this.state;
    return (
      <Row>
        <Col span={24}>
          <StyledContent>
            <section>
              {
                isLoading  ?
                (
                  <ComponentContainer
                    title={error}
                    loading={isLoading}
                    empty={error}
                    resetData={this.getPortfolioSnapshot}
                  >
                    <p>Risk Profile</p>
                  </ComponentContainer>
                ) :
                (
                  <RiskProfileComponent selectedTrade={selectedTrade}/>
                )
              }
            </section>
          </StyledContent>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  portfolios: state.portfolios,
})

const mapDispatchToProps = (dispatch: Function) => ({
  getPortfoliosList() {
    getPortfolioSnapshot(dispatch)
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(RiskProfile2)



// WEBPACK FOOTER //
// ./src/components/view-trades/AnalyzeTrade.js